import { VueUserContextModel } from "@/core/models";
import { StorageService } from "./storage.service";

export const RedirectService = {
  getDefaultAuthenticatedRoute(userContext: VueUserContextModel, isAuthenticated: boolean) {
    if (!isAuthenticated || !userContext?.userId) {
      throw new Error("User is not initialized");
    }

    const redirectUrl = StorageService.getAndRemoveRedirectToUrl();
    if (redirectUrl) {
      return redirectUrl;
    }

    // TODO: Implement correct redirects

    // If unsure, return admin
    return "/home";
  },
};
